import React from 'react';
import './KullanimKilavuzu.css';
import { FaEye, FaDownload } from 'react-icons/fa';

const KullanimKilavuzu = () => {
  const pdfUrl = "/kullanim-kilavuzu.pdf";

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'kullanim-kilavuzu.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="kilavuz-container">
      <div className="kilavuz-header">
        <h1>Kullanım Kılavuzu</h1>
        <p>Ürünümüzü en verimli şekilde kullanabilmeniz için hazırladığımız detaylı kılavuzu inceleyebilir veya cihazınıza indirebilirsiniz.</p>
      </div>

      <div className="action-card">
        <h2 className="action-title">Kılavuz Erişim Seçenekleri</h2>
        <div className="button-group">
          <button 
            onClick={() => window.open(pdfUrl, '_blank')}
            className="pdf-btn btn-view"
          >
            <FaEye className="icon" />
            PDF'yi Görüntüle
          </button>
          
          <button 
            onClick={handleDownload}
            className="pdf-btn btn-download"
          >
            <FaDownload className="icon" />
            PDF'yi İndir
          </button>
        </div>
      </div>

      <div className="pdf-viewer-container">
        <iframe 
          src={pdfUrl} 
          className="pdf-viewer"
          title="Kullanım Kılavuzu"
        />
      </div>
    </div>
  );
};

export default KullanimKilavuzu;